module.exports = __webpack_public_path__ + "static/media/gongcheng1.fce0460f.png";